import React from 'react'
import Header from '../components/Header'
import Courosel from '../components/Courosel'
import Footer from '../components/Footer'
function Home() {
    return (
        <div>
            <Header />
            <div className="introduction flex-with-center" style={{ backgroundImage: `url('./intobg.svg')` }}>
                <div>
                    <h1 data-aos="fade-up">DEVESH BHUSHAN</h1>
                    <div className="d-flex justify-content-between intro-content">
                        <p>
                            MERN Stack <br />Developer,Competitive Coder
                        </p>
                        <button className="primary-button font-bold "><a  href = "#courosel">Get Started</a></button>
                    </div>
                </div>
            </div>
            <Courosel />
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
                    <path fill="#001220" fill-opacity="1" d="M0,224L20,208C40,192,80,160,120,154.7C160,149,200,171,240,186.7C280,203,320,213,360,181.3C400,149,440,75,480,48C520,21,560,43,600,74.7C640,107,680,149,720,186.7C760,224,800,256,840,261.3C880,267,920,245,960,213.3C1000,181,1040,139,1080,149.3C1120,160,1160,224,1200,234.7C1240,245,1280,203,1320,176C1360,149,1400,139,1420,133.3L1440,128L1440,0L1420,0C1400,0,1360,0,1320,0C1280,0,1240,0,1200,0C1160,0,1120,0,1080,0C1040,0,1000,0,960,0C920,0,880,0,840,0C800,0,760,0,720,0C680,0,640,0,600,0C560,0,520,0,480,0C440,0,400,0,360,0C320,0,280,0,240,0C200,0,160,0,120,0C80,0,40,0,20,0L0,0Z"></path>
                </svg>
            </div>
            <div className="container">
                <div className='row justify-content-start'>
                    <div className="col-md-4">
                        <div className="n-box2 p-5 font-bold" data-aos='fade-right'>
                            <h1>Yes you are<br /> right...</h1>
                            <p>I am a javascript buff...</p>
                        </div>
                    </div>
                </div>
                <div className='row pt-5 justify-content-center'>
                    <div className="col-md-4">
                        <div className="n-box2 p-3">
                            <img src="./javascriptbuffer.png" height="200" className="w-100" alt="" data-aos="fade-up" />
                        </div>
                    </div>
                </div>
                <div className='row pt-5 justify-content-end'>
                    <div className="col-md-4">
                        <div className="n-box2 p-5 font-bold" data-aos="fade-left">
                            <p>JavaScript, often abbreviated as JS, is a programming language that conforms
                                to the ECMAScript specification. JavaScript is high-level, often just-in-time
                                compiled and multi-paradigm. It has dynamic typing, prototype-based object-orientation
                                and first-class functions</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className='container mt-5 n-box2 py-5 px-3 devstack'>
                <div className="text-center">
                    <h3 className="font-bold text-center">My Development Stack</h3>
                    <img src="./developer.png" height="200" width="200" alt="" className="text-center circleimg" />
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="font-bold">
                            <h3 className="font-bold">Web Development</h3>
                            <hr />
                            <p>HTML 5</p>
                            <p>CSS</p>
                            <p>Bootstrap</p>
                            <p>React</p>
                            <p>UI/UX</p>
                            <p>Node js</p>
                            <p>Express</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="font-bold text-center">
                            <h3 className="font-bold">Coding</h3>
                            <hr />
                            <p>C</p>
                            <p>C++</p>
                            <p>Data Structures</p>
                            <p>Algorithms</p>
                            <p>Python</p>
                            <p>JAVA</p>
                    
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="font-bold text-right">
                            <h3 className="font-bold">DB/Subjects</h3>
                            <hr />
                            <p>MYSQL</p>
                            <p>MongoDB</p>
                            <p>Github</p>
                            <p>Computer Networks</p>
                            <p>OOPS</p>
                            <p>Operating System</p>
                        </div>
                    </div>

                </div>
            </div>
            <div>
                <div className="font-bold text-center mt-5"><h3>Who Is Devesh??</h3></div>
                <div className="who-is-devesh mt-5 flex-with-center" style={{ backgroundImage: `url("./deveshbg.svg ")` }}>
                    <div>
                        <h3>Hi,Hello,Namaste</h3>
                        <p><pre>{JSON.stringify({
                            name: "Devesh Bhushan",
                            from: "Kanpur",
                            age: "20",
                            gender: "Male"
                        }, null, 2)}
                        </pre></p>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Home
